var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sale",
    transform: "translate(-546 -667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 14,
    height: 14,
    transform: "translate(546 667)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M94.022,14.28a.478.478,0,0,0-.672,0l-1.2,1.2-3.35-.022a1.1,1.1,0,0,0-.781.314l-3.838,3.849a1.093,1.093,0,0,0,0,1.539l2.96,2.96a1.093,1.093,0,0,0,1.539,0l3.838-3.838a1.054,1.054,0,0,0,.314-.781l-.011-3.35,1.2-1.2a.478.478,0,0,0,0-.672Zm-5.811,8.164a.393.393,0,0,1-.542,0l-1.811-1.821a.383.383,0,0,1,.542-.542l1.811,1.811A.393.393,0,0,1,88.211,22.443Zm1.182-1.182a.393.393,0,0,1-.542,0L87.04,19.451a.383.383,0,1,1,.542-.542l1.811,1.811a.38.38,0,0,1,0,.542Zm1.117-2.569a.9.9,0,1,1,.9-.9A.9.9,0,0,1,90.51,18.692Z",
    transform: "translate(464.139 654.858)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale2);
export default __webpack_public_path__ + "static/media/Sale2.278b0b2b4c2171dfac4a380abceb14c3.svg";
export { ForwardRef as ReactComponent };